export default "__VITE_ASSET__BDON5Vb9__"